// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3rHIk","choiceBoxes":"toolbarselects_choiceBoxes__jL2Fu","simpleField":"toolbarselects_simpleField__1NSTS"};